// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/fonts/bebas-neue/bebasneueregular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/public/fonts/bebas-neue/bebasneueregular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("/public/fonts/bebas-neue/bebasneueregular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("/public/fonts/bebas-neue/bebasneuethin.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("/public/fonts/bebas-neue/bebasneuethin.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("/public/fonts/bebas-neue/bebasneuethin.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("/public/fonts/bebas-neue/bebasneuebold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("/public/fonts/bebas-neue/bebasneuebold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("/public/fonts/bebas-neue/bebasneuebold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("/public/fonts/bebas-neue/bebasneuebook.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("/public/fonts/bebas-neue/bebasneuebook.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("/public/fonts/bebas-neue/bebasneuebook.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("/public/fonts/bebas-neue/bebasneuelight.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("/public/fonts/bebas-neue/bebasneuelight.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("/public/fonts/bebas-neue/bebasneuelight.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New",
    monospace;
}

.ant-table-tbody {
  padding: 11px !important;
  background: white;
}

.ant-table-tbody > tr > td {
  padding: 11px !important;
}

.ant-table-body {
  height: 100vh;
}

::-webkit-scrollbar-track {
  background-color: #f5f5f5;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}

::-webkit-scrollbar {
  width: 8px;
  background-color: #f5f5f5;
}

::-webkit-scrollbar:horizontal {
  height: 8px;
  background-color: #f5f5f5;
}

::-webkit-scrollbar-thumb {
  background-color: #096dd9;
  background-image: -webkit-linear-gradient(
    45deg,
    rgba(255, 255, 255, 0.2) 25%,
    transparent 25%,
    transparent 50%,
    rgba(255, 255, 255, 0.2) 50%,
    rgba(255, 255, 255, 0.2) 75%,
    transparent 75%,
    transparent
  );
  border-radius: 5px;
}

.loading-overlay {
    position: relative;
    background-color: rgba(255, 255, 255, 0.7);
    z-index: 10000;
    pointer-events: none;
}

.loader {
    border: 5px solid rgba(0, 0, 0, 0.1);
    border-left-color: #4285f4;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    animation: spin 1s linear infinite;
    position: absolute;
    top: 50%;
    left: 45%;
    z-index: 10000;
}

.small-loader {
    width: 12px;
    height: 12px;
}

.loader-top {
    top: 30%
}

@keyframes spin {
    100% {
        transform: rotate(360deg);
    }
}

@font-face {
  font-family: 'BebasNeue';
  font-weight: normal;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2'),
       url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff'),
       url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype');
}

@font-face {
  font-family: 'BebasNeue';
  font-weight: 200; /* thin */
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff2'),
       url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('woff'),
       url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('truetype');
}

@font-face {
  font-family: 'BebasNeue';
  font-weight: bold;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('woff2'),
       url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format('woff'),
       url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format('truetype');
}

@font-face {
  font-family: 'BebasNeue';
  font-weight: 300; /* book */
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format('woff2'),
       url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format('woff'),
       url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format('truetype');
}

@font-face {
  font-family: 'BebasNeue';
  font-weight: lighter; /* light */
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format('woff2'),
       url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format('woff'),
       url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format('truetype');
}

.bebas-neue-font {
  font-family: 'BebasNeue', sans-serif;
  font-weight: normal;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,oDAAoD;AACtD;;AAEA;EACE,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB;;;;;;;;;GASC;EACD,kBAAkB;AACpB;;AAEA;IACI,kBAAkB;IAClB,0CAA0C;IAC1C,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,oCAAoC;IACpC,0BAA0B;IAC1B,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kCAAkC;IAClC,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB;;iEAE4E;AAC9E;;AAEA;EACE,wBAAwB;EACxB,gBAAgB,EAAE,SAAS;EAC3B,kBAAkB;EAClB;;iEAEyE;AAC3E;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,kBAAkB;EAClB;;iEAEyE;AAC3E;;AAEA;EACE,wBAAwB;EACxB,gBAAgB,EAAE,SAAS;EAC3B,kBAAkB;EAClB;;kEAEyE;AAC3E;;AAEA;EACE,wBAAwB;EACxB,oBAAoB,EAAE,UAAU;EAChC,kBAAkB;EAClB;;kEAE0E;AAC5E;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;AACrB","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\",\n    \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\",\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\",\n    monospace;\n}\n\n.ant-table-tbody {\n  padding: 11px !important;\n  background: white;\n}\n\n.ant-table-tbody > tr > td {\n  padding: 11px !important;\n}\n\n.ant-table-body {\n  height: 100vh;\n}\n\n::-webkit-scrollbar-track {\n  background-color: #f5f5f5;\n  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n}\n\n::-webkit-scrollbar {\n  width: 8px;\n  background-color: #f5f5f5;\n}\n\n::-webkit-scrollbar:horizontal {\n  height: 8px;\n  background-color: #f5f5f5;\n}\n\n::-webkit-scrollbar-thumb {\n  background-color: #096dd9;\n  background-image: -webkit-linear-gradient(\n    45deg,\n    rgba(255, 255, 255, 0.2) 25%,\n    transparent 25%,\n    transparent 50%,\n    rgba(255, 255, 255, 0.2) 50%,\n    rgba(255, 255, 255, 0.2) 75%,\n    transparent 75%,\n    transparent\n  );\n  border-radius: 5px;\n}\n\n.loading-overlay {\n    position: relative;\n    background-color: rgba(255, 255, 255, 0.7);\n    z-index: 10000;\n    pointer-events: none;\n}\n\n.loader {\n    border: 5px solid rgba(0, 0, 0, 0.1);\n    border-left-color: #4285f4;\n    border-radius: 50%;\n    width: 50px;\n    height: 50px;\n    animation: spin 1s linear infinite;\n    position: absolute;\n    top: 50%;\n    left: 45%;\n    z-index: 10000;\n}\n\n.small-loader {\n    width: 12px;\n    height: 12px;\n}\n\n.loader-top {\n    top: 30%\n}\n\n@keyframes spin {\n    100% {\n        transform: rotate(360deg);\n    }\n}\n\n@font-face {\n  font-family: 'BebasNeue';\n  font-weight: normal;\n  font-style: normal;\n  src: url('/public/fonts/bebas-neue/bebasneueregular.woff2') format('woff2'),\n       url('/public/fonts/bebas-neue/bebasneueregular.woff') format('woff'),\n       url('/public/fonts/bebas-neue/bebasneueregular.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'BebasNeue';\n  font-weight: 200; /* thin */\n  font-style: normal;\n  src: url('/public/fonts/bebas-neue/bebasneuethin.woff2') format('woff2'),\n       url('/public/fonts/bebas-neue/bebasneuethin.woff') format('woff'),\n       url('/public/fonts/bebas-neue/bebasneuethin.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'BebasNeue';\n  font-weight: bold;\n  font-style: normal;\n  src: url('/public/fonts/bebas-neue/bebasneuebold.woff2') format('woff2'),\n       url('/public/fonts/bebas-neue/bebasneuebold.woff') format('woff'),\n       url('/public/fonts/bebas-neue/bebasneuebold.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'BebasNeue';\n  font-weight: 300; /* book */\n  font-style: normal;\n  src: url('/public/fonts/bebas-neue/bebasneuebook.woff2') format('woff2'),\n       url('/public/fonts/bebas-neue/bebasneuebook.woff') format('woff'),\n       url('/public/fonts/bebas-neue/bebasneuebook.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'BebasNeue';\n  font-weight: lighter; /* light */\n  font-style: normal;\n  src: url('/public/fonts/bebas-neue/bebasneuelight.woff2') format('woff2'),\n       url('/public/fonts/bebas-neue/bebasneuelight.woff') format('woff'),\n       url('/public/fonts/bebas-neue/bebasneuelight.ttf') format('truetype');\n}\n\n.bebas-neue-font {\n  font-family: 'BebasNeue', sans-serif;\n  font-weight: normal;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
